var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "turn"
  }, [_c('m-head', {
    ref: "mHeadRef"
  }), _c('div', {
    staticClass: "turn-body"
  }, [_c('div', {
    staticClass: "turn-main"
  }, [_c('div', {
    staticClass: "turn-box-bg",
    style: {
      background: `url(${require(`@images/lucky/lucky-page-bg.jpg`)}) center top/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "turn-container"
  }, [_c('div', {
    staticClass: "turn-bg",
    style: {
      background: `url(${require(`@images/lucky/lucky-bg.png`)}) center top/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "turn-light"
  }, [_c('div', {
    ref: "light1Ref",
    staticClass: "light1"
  }), _c('div', {
    ref: "light2Ref",
    staticClass: "light2"
  })]), _c('div', {
    staticClass: "turn-con",
    attrs: {
      "id": "luckyTableMain"
    }
  }, [_vm.prizeList ? [_c('lucky-wheel', {
    ref: "vueLuckywheel",
    attrs: {
      "prize-index": _vm.prizeIndex
    },
    on: {
      "game-over": _vm.onResult
    }
  }, _vm._l(_vm.prizeList, function (prize, index) {
    return _c('lucky-wheel-item', {
      key: index
    }, [prize ? [_c('transition', {
      attrs: {
        "appear": "",
        "name": "prizeScaleAnim",
        "tag": "div"
      }
    }, [_c('div', {
      staticClass: "luckyTable-item",
      class: index == _vm.prizeIndex && _vm.isResultAnim && 'result'
    }, [_c('div', {
      staticClass: "luckyTable-item-main",
      class: index % 2 ? 'even' : 'odd'
    }, [_c('div', {
      staticClass: "luckyTable__num"
    }, [_vm._v(_vm._s(_vm._f("fmt_pre")(prize.value)))]), _c('div', {
      staticClass: "luckyTable__unit"
    }, [_vm._v(_vm._s(prize.type == "COIN" ? "FANPOINTS" : prize.type.toUpperCase()))]), _c('div', {
      staticClass: "luckyTable__icon",
      style: {
        backgroundImage: `url(${require(`@images/${_vm.aiSkin}/icon-${prize.type.toLowerCase()}.png`)})`
      }
    })])])])] : _vm._e()], 2);
  }), 1)] : _vm._e()], 2), _c('div', {
    staticClass: "turn-btns"
  }, [_vm.luckyInfo && JSON.stringify(_vm.luckyInfo) != '{}' ? [!_vm.isPageLoading ? _c('div', {
    staticClass: "btn-turn",
    class: _vm.isBtnLoading && 'disable',
    style: {
      background: `url(${require(`@images/lucky/lucky-btn1-bg.png`)}) center top/100% auto no-repeat`
    },
    on: {
      "click": _vm.onStart
    }
  }, [_c('div', {
    staticClass: "btn-turn-main"
  }, [_vm._v(" SPIN ")])]) : _vm._e()] : _vm.luckyInfo && JSON.stringify(_vm.luckyInfo) == '{}' ? [_c('div', {
    staticClass: "btn-turn"
  }, [_c('div', {
    staticClass: "btn-turn-main under"
  }, [_c('div', {
    staticClass: "under-main",
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm._v(" Under maintenance "), _c('div', {
    staticClass: "icon-refresh"
  }, [_c('svg-icon', {
    attrs: {
      "spin": _vm.isRefresh,
      "name": "icon-refresh"
    }
  })], 1)])])])] : [_vm._m(0)]], 2)]), _c('div', {
    staticClass: "turn-balance"
  }, [_c('div', {
    staticClass: "turn-balance-main"
  }, [_vm._v(" Spins:   "), _c('span', {
    attrs: {
      "id": "spinsBalanceId"
    }
  }, [_vm._v(_vm._s(_vm.fmt_pre(_vm.spinsBalanceInfo.balance)) + " "), _c('div', {
    staticClass: "stock-number",
    attrs: {
      "id": "stockNumberDiv"
    }
  })]), _vm._v("/" + _vm._s(_vm.fmt_pre(_vm.spinsBalanceInfo.max)) + " ")]), _c('div', {
    staticClass: "btns"
  }, [_vm.spinsBalanceInfo.recovery.countdown > 0 && _vm.spinsBalanceInfo.recovery.count > 0 ? _c('div', {
    staticClass: "coundown"
  }, [_c('span', [_vm._v("+" + _vm._s(_vm.spinsBalanceInfo.recovery.count) + " Spins")]), _vm._v(" "), _vm.spinsBalanceInfo.recovery.countdown > 0 ? _c('span', [_c('svg-icon', {
    attrs: {
      "name": "icon-time"
    }
  }), _vm._v(_vm._s(_vm.fmt_cjs(_vm.spinsBalanceInfo.recovery.countdown)) + " ")], 1) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "btn-add",
    on: {
      "click": () => _vm.popBuySpinsShow = true
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-add"
    }
  })], 1)])])])]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "className": "popEnough",
      "show": _vm.popStockEnoughShow,
      "content": "html",
      "title": " ",
      "isBtnCancel": false,
      "confirmText": "Get"
    },
    on: {
      "update:show": function ($event) {
        _vm.popStockEnoughShow = $event;
      },
      "confirm": _vm.onEnoughConfirm
    }
  }, [_c('div', {
    staticClass: "pop-enough"
  }, [_c('div', {
    staticClass: "pop-enough__icon"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/icon-spins.png`),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "pop-enough__label"
  }, [_vm._v("Insufficient Spins")])])]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "className": "popBuyDiamondClass",
      "show": _vm.popBuySpinsShow,
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html"
    },
    on: {
      "update:show": function ($event) {
        _vm.popBuySpinsShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-buyDiamond"
  }, [_c('div', {
    staticClass: "pop-buyDiamond__title"
  }, [_vm._v("Spins")]), _c('div', {
    staticClass: "pop-buyDiamond-list"
  }, [_c('transition-group', {
    staticClass: "pop-buyDiamond-scroll",
    attrs: {
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterLongList
    }
  }, [_vm.sellSpinsList ? _vm._l(_vm.sellSpinsList, function (item, index) {
    return _c('div', {
      key: `mp${index}`,
      staticClass: "pop-buyDiamond-item off",
      class: [index == 3 && 'popular', index == _vm.sellSpinsList.length - 1 && 'best'],
      attrs: {
        "data-index": index <= 50 ? index + 1 : 0
      }
    }, [index == 3 || _vm.sellSpinsList.length - 1 == index ? _c('div', {
      staticClass: "pop-buyDiamond-item-tag"
    }, [index == 3 ? [_vm._v("POPULAR")] : _vm._e(), index == _vm.sellSpinsList.length - 1 ? [_vm._v("BEST DEAL")] : _vm._e()], 2) : _vm._e(), _c('div', {
      staticClass: "pop-buyDiamond-item-main"
    }, [_c('div', {
      staticClass: "pop-buyDiamond-item__spins"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/icon-spins.png`),
        "alt": ""
      }
    }), _vm._v("x" + _vm._s(_vm.fmt_pre(item.spin - item.bonus)))]), _c('div', {
      staticClass: "pop-buyDiamond-item__sub"
    }, [item.off ? _c('span', [_vm._v(_vm._s(item.off))]) : _vm._e()]), _c('div', {
      staticClass: "pop-buyDiamond-item-info",
      on: {
        "click": function ($event) {
          return _vm.onPaySpins(item);
        }
      }
    }, [_c('div', {
      staticClass: "pop-buyDiamond-item-info__price"
    }, [!item.loading ? [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/icon-diamond.png`),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(item.diamond)))])] : [_c('div', {
      staticClass: "circleLoading"
    })]], 2)])])]);
  }) : _vm._e()], 2)], 1)])]), _c('m-menu')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "btn-turn"
  }, [_c('div', {
    staticClass: "btn-turn-main loading"
  }, [_c('div', {
    staticClass: "circleLoading"
  })])]);
}];
export { render, staticRenderFns };